import { AxiosInstance } from 'axios';
import { IAnalyticsService } from './IAnalyticsService';

export class AnalyticsService implements IAnalyticsService {
    constructor(
        private readonly axios: AxiosInstance
    ) {
    }

    public readonly notifyEvent = (
        eventName: string,
        eventData: any,
        isBulkPayment?: boolean
    ) => {
        this.sendEvent(eventName, eventData, isBulkPayment);
    };

    private readonly sendEvent = (
        eventName: string,
        eventData: any,
        isBulkPayment?: boolean
    ) => {
        this.axios.request({
                method: 'POST',
                url: isBulkPayment ?  `/bulk-analytic-track/${eventName}` : `/analytic-track/${eventName}`,
                data: {
                    activityData: eventData
                }
            }
        ).catch(err => {
            console.error(err.message);
        });
    };
}
